import { render } from "./image-field.vue?vue&type=template&id=32d3addb"
import script from "./image-field.vue?vue&type=script&lang=js"
export * from "./image-field.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./image-field.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__